import axios from "axios"
import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setOpenAddArticleAPI, setOpenArticleManagment, setOpenChoiceComponentAR } from "../../Reducer/ModalSlice"
import { IoClose } from "react-icons/io5"
import { setEditAddedArticleAPI } from "../../Reducer/AddArticleInAPISlice"

function ArticleManagment(){
    const User = useSelector(state => state.UserSlice.User)
    const Server = useSelector(state => state.UserSlice.Server)
    
    const [ArticleArray, setArticleArray] = useState() 
    const [CancelTouch, setCancelTouch] = useState(false)
    const [isLoading, setLoading] = useState(true)
    const [OpenDeletedModal, setOpenDeletedModal] = useState(false)
    const [DeletedArticle, setDeletedArticle] = useState('')

    const dispatch = useDispatch()

    const getArticle = async () => {
        setLoading(false)
        axios.get(Server + 'articlesofmoneymovements?_limit=-1', {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        .then((response) => {
            setArticleArray(response.data)
            setLoading(true)
        })
    }

    const handleClickDeleteArticle = async (Id) => {
        setLoading(false)
        await axios.delete(Server + 'articlesofmoneymovements/' + Id, {
            headers: {
                Authorization: 'Bearer ' + User.jwt,
            }
        })
        await getArticle()
    }

    useEffect(() => {
        getArticle();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(!isLoading)
        return(
        <div
        className="AddArticleEDGlobalDiv"
        >
                <div
                className="BigSpin"
                />
        </div>
    )

    if(ArticleArray)
    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalStaffManagmentMainDiv"
            >          
            <div
                className="ModalInformationDiv"
                >
                    <div
                    className="ModalInformationTextDiv"
                    >
                        Изменение статей
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() =>{
                        dispatch(setOpenArticleManagment(false))
                        dispatch(setOpenChoiceComponentAR(true))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) =>{
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenArticleManagment(false))
                            dispatch(setOpenChoiceComponentAR(true))
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div> 
                <div
                className="ModalStaffManagmentDiv"
                >
                    {ArticleArray.map((el) => 
                    el.Name !== 'Заработная плата' && el.Name !== 'Оплата доставки' && el.Name !== 'Закупка' &&
                    <div
                    className={"OneStaffManagmentDiv " + el.Type}
                    >
                        <div>
                            {el.Name}
                        </div>
                        <div
                        className="DivFlex Gap"
                        >
                            <button
                            className="ModalDeletedStaffButton Delete"
                            onClick={(() => {
                                setOpenDeletedModal(true)
                                setDeletedArticle(el)
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) =>{
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    setOpenDeletedModal(true)
                                    setDeletedArticle(el)
                                }
                            })}
                            >
                                Удалить
                            </button>               

                            <button
                            className="ModalDeletedStaffButton UnDelete"
                            onClick={(() => {
                                dispatch(setEditAddedArticleAPI({
                                    EditCheck: true, 
                                    id: el.id, 
                                    Name: el.Name, 
                                    OtherExpenditure: el.OtherExpenditure, 
                                    TransactionType: el.TransactionType, 
                                    Type: el.Type
                                }))
                                dispatch(setOpenAddArticleAPI(true))
                                dispatch(setOpenArticleManagment(false))
                            })}
                            onTouchStart={() => {
                                setCancelTouch(false)
                            }}
                            onTouchMove={() => {
                                setCancelTouch(true)
                            }}
                            onTouchCancel={() => {
                                setCancelTouch(true)
                            }}
                            onTouchEnd={((event) =>{
                                event.preventDefault()
                                if(!CancelTouch)
                                {
                                    dispatch(setEditAddedArticleAPI({
                                        EditCheck: true, 
                                        id: el.id, 
                                        Name: el.Name, 
                                        OtherExpenditure: el.OtherExpenditure, 
                                        TransactionType: el.TransactionType, 
                                        Type: el.Type
                                    }))
                                    dispatch(setOpenAddArticleAPI(true))
                                    dispatch(setOpenArticleManagment(false))
                                }
                            })}
                            >
                                Изменить
                            </button>            
                        </div>
                    </div>
                    )}
                </div> 
            </div>

            {OpenDeletedModal &&
            <div
            className="AddArticleEDGlobalDiv"
            >
                <div
                className="ModalChangeHiddenMainDiv"
                >
                    <div>
                    {'Подтвердите удаление статьи ' + DeletedArticle.Name}
                    </div>
                    <div
                    className="ModalChangeHiddenButtonsDiv"
                    >
                        <button
                        className="ModalChangeHiddenButton Cancle"
                        onClick={(() => {
                            setOpenDeletedModal(false)
                        })}
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                                setOpenDeletedModal(false)
                        })}
                        >
                            Отмена
                        </button>
                        <button
                        className="ModalChangeHiddenButton Ok"    
                        onClick={(() => {
                            handleClickDeleteArticle(DeletedArticle.id)
                            setOpenDeletedModal(false)
                        })}      
                        onTouchStart={() => {
                            setCancelTouch(false)
                        }}
                        onTouchMove={() => {
                            setCancelTouch(true)
                        }}
                        onTouchCancel={() => {
                            setCancelTouch(true)
                        }}
                        onTouchEnd={((event) => {
                            event.preventDefault()
                            if(!CancelTouch)
                            {
                                handleClickDeleteArticle(DeletedArticle.id)
                                setOpenDeletedModal(false)
                            }
                        })}             
                        >
                            Ок
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
    )
}

export default ArticleManagment